import { makeStyles } from '@material-ui/core/styles';

export const useProfileStyles = makeStyles(() => ({
  text: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 5,
  },
  text2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonRPGO: {
    marginTop: 10,
  },
  centerText: {
    textAlign: 'center',
  },
  image: {
    height: 33,
    width: 84,
  },
  link: {
    textDecoration: 'none',
    color: '#464646',
  },
}));

export const useProfileRingStyles = makeStyles(() => ({
  circleContainer: {
    marginTop: -25,
    marginBottom: 15,
  },
  bottom: {
    color: '#CCCCCC',
  },
  circle: {
    color: (props) => props.color,
    position: 'absolute',
    '& .MuiCircularProgress-circle': {
      strokeLinecap: 'round',
    },
  },
}));
